import React from 'react'

const DocumentDesignation = ({ designation }) => {
    if(designation === null || designation.length === 0) return null
     return (
       <>
      <p className="h6 font-weight-bold">Document Number</p>
      <p>{designation}</p>
      </>
     )
  }

export default DocumentDesignation;